import type { ColumnLabelDefinition } from './column-label-definitions';

export const ORDER_EXPLORER_COLUMN_LABELS = {
	orderTitle: { id: 'orderTitle', label: 'DISPATCH_LIST.ORDER' },
	priority: { id: 'priority', label: 'DISPATCH_LIST.PRIORITY' },
	assignedTo: { id: 'assignedTo', label: 'DISPATCH_LIST.ASSIGNED_TO' },
	status: { id: 'status', label: 'DISPATCH_LIST.STATUS' },
	firstWayPointCustomerName: {
		id: 'firstWayPointCustomerName',
		label: 'DISPATCH_LIST.WAY_POINTS_FIRST_CUSTOMER_NAME'
	},
	lastWayPointCustomerName: {
		id: 'lastWayPointCustomerName',
		label: 'DISPATCH_LIST.WAY_POINTS_LAST_CUSTOMER_NAME'
	},
	timeWindow: { id: 'timeWindow', label: 'DISPATCH_LIST.TIME_WINDOW' },
	firstWayPointEta: { id: 'firstWayPointEta', label: 'DISPATCH_LIST.WAY_POINTS_FIRST_ETA' },
	lastWayPointEta: { id: 'lastWayPointEta', label: 'DISPATCH_LIST.WAY_POINTS_LAST_ETA' },
	firstWayPointScheduledAt: {
		id: 'firstWayPointScheduledAt',
		label: 'DISPATCH_LIST.WAY_POINTS_FIRST_SCHEDULED_AT'
	},
	lastWayPointScheduledAt: {
		id: 'lastWayPointScheduledAt',
		label: 'DISPATCH_LIST.WAY_POINTS_LAST_SCHEDULED_AT'
	},
	firstWayPointAddressType: { id: 'firstWayPointAddressType', label: 'DISPATCH_LIST.ADDRESS_TYPE_NAME_FIRST' },
	lastWayPointAddressType: { id: 'lastWayPointAddressType', label: 'DISPATCH_LIST.ADDRESS_TYPE_NAME_LAST' },
	firstWayPointAddress: { id: 'firstWayPointAddress', label: 'DISPATCH_LIST.WAY_POINTS_FIRST_ADDRESS' },
	lastWayPointAddress: { id: 'lastWayPointAddress', label: 'DISPATCH_LIST.WAY_POINTS_LAST_ADDRESS' },
	lastWayPointFullAddress: {
		id: 'lastWayPointFullAddress',
		label: 'DISPATCH_LIST.WAY_POINTS_LAST_FULL_ADDRESS'
	},
	firstWayPointAddressSecondLine: {
		id: 'firstWayPointAddressSecondLine',
		label: 'DISPATCH_LIST.WAY_POINTS_FIRST_ADDRESS_SECOND_LINE'
	},
	lastWayPointAddressSecondLine: {
		id: 'lastWayPointAddressSecondLine',
		label: 'DISPATCH_LIST.WAY_POINTS_LAST_ADDRESS_SECOND_LINE'
	},
	lastWayPointCity: { id: 'lastWayPointCity', label: 'ORDER_DETAILS.LIST.CITY' },
	orderTag: { id: 'orderTag', label: 'DISPATCH_LIST.ORDER_TAG' },
	tag: { id: 'tag', label: 'DISPATCH_LIST.TAG' },
	servicePlanName: { id: 'servicePlanName', label: 'DISPATCH_LIST.SERVICE_PLAN_NAME' },
	reservedUntil: { id: 'reservedUntil', label: 'DISPATCH_LIST.RESERVED_UNTIL' },
	requiredSkills: { id: 'requiredSkills', label: 'DISPATCH_LIST.SKILLS' },
	rank: { id: 'rank', label: 'DISPATCH_LIST.RANK' },
	readyForPickup: { id: 'readyForPickup', label: 'DISPATCH_LIST.READY_FOR_PICKUP' },
	orderCreated: { id: 'orderCreated', label: 'DISPATCH_LIST.ORDER_CREATED' },
	groupFollowers: { id: 'groupFollowers', label: 'DISPATCH_LIST.GROUP_FOLLOWERS' },
	taskTypeId: { id: 'taskTypeId', label: 'DISPATCH_LIST.TASK_TYPE' },
	nextStop: { id: 'nextStop', label: 'DISPATCH_LIST.NEXT_STOP' },
	totalWeight: { id: 'totalWeight', label: 'DISPATCH_LIST.TOTAL_WEIGHT' },
	totalQuantity: { id: 'totalQuantity', label: 'DISPATCH_LIST.TOTAL_QUANTITY' },
	scheduledFor: { id: 'scheduledFor', label: 'DISPATCH_LIST.SCHEDULED_FOR' },
	taskProgress: { id: 'taskProgress', label: 'DISPATCH_LIST.PROGRESS' },
	lastWayPointEtl: { id: 'lastWayPointEtl', label: 'DISPATCH_LIST.WAY_POINTS_LAST_ETL' },
	lastWayPointCustomerPhone: {
		id: 'lastWayPointCustomerPhone',
		label: 'DISPATCH_LIST.WAY_POINTS_LAST_PHONE'
	},
	lastWayPointZipcode: { id: 'lastWayPointZipcode', label: 'DISPATCH_LIST.WAY_POINTS_LAST_ZIPCODE' },
	lastWayPointFirstAttemptPromiseNoEarlierThan: {
		id: 'lastWayPointFirstAttemptPromiseNoEarlierThan',
		label: 'DISPATCH_LIST.WAY_POINTS_LAST_FIRST_ATTEMPT_PROMISE_EARLIER_THAN'
	},
	lastWayPointFirstAttemptPromiseNoLaterThan: {
		id: 'lastWayPointFirstAttemptPromiseNoLaterThan',
		label: 'DISPATCH_LIST.WAY_POINTS_LAST_FIRST_ATTEMPT_PROMISE_LATER_THAN'
	},
	timeUntilSchedule: { id: 'timeUntilSchedule', label: 'DISPATCH_LIST.TIME_UNTIL_FIRST_WAY_POINT_SCHEDULED' },
	lastWayPointEtos: { id: 'lastWayPointEtos', label: 'DISPATCH_LIST.WAY_POINTS_LAST_ETOS' },
	firstWayPointScheduledArrival: { id: 'firstWayPointScheduledArrival', label: 'ORDER.SCHEDULED_ARRIVAL' },
	preparationExternalId: { id: 'preparationExternalId', label: 'ORDER_DETAILS.LIST.PREPARATION_EXTERNAL_ID' },
	serviceAreaFirstStop: { id: 'serviceAreaFirstStop', label: 'DISPATCH_LIST.WAY_POINTS_FIRST_SERVICE_AREA' },
	serviceAreaLastStop: { id: 'serviceAreaLastStop', label: 'DISPATCH_LIST.WAY_POINTS_LAST_SERVICE_AREA' },
	donePlanning: { id: 'donePlanning', label: 'MONITORING.DONE_PLANNING_HEADER' }
} as const satisfies Record<string, ColumnLabelDefinition>;

export const ORDER_EXPLORER_OPTIONAL_COLUMN_LABELS = {
	wayPointsTimeZones: { id: 'wayPointsTimeZones', label: 'DISPATCH_LIST.WAY_POINTS_TIME_ZONE' },
	runTitle: { id: 'runTitle', label: 'DISPATCH_LIST.ROUTE_NAME' },
	totalPrice: { id: 'totalPrice', label: 'DISPATCH_LIST.PRICE' },
	fleetId: { id: 'fleet_id', label: 'ORDER_DETAILS.CARRIER' },
	vehicleName: { id: 'vehicleName', label: 'DISPATCH_LIST.VEHICLE_NAME' }
} as const satisfies Record<string, ColumnLabelDefinition>;

export const ORDER_EXPLORER_COLUMN_LABEL_DEFINITIONS = Object.values(ORDER_EXPLORER_COLUMN_LABELS);

export const ROUTE_MONITOR_COLUMN_LABELS = {
	driverName: { id: 'driver-name', label: 'ROUTE_MONITORING.DETAILED_TABLE.ASSIGNED_DRIVER' },
	trailer: { id: 'trailer', label: 'ROUTE_MONITORING.DETAILED_TABLE.TRAILER_NAME' },
	fulfillment: { id: 'fulfillment', label: 'ROUTE_MONITORING.DETAILED_TABLE.FULFILLMENT.TITLE' },
	startedAt: { id: 'started-at', label: 'ROUTE_MONITORING.DETAILED_TABLE.START_TIME' },
	endedAt: { id: 'ended-at', label: 'ROUTE_MONITORING.DETAILED_TABLE.END_TIME' },
	scheduledStartTime: { id: 'scheduled-start-time', label: 'ROUTE_MONITORING.DETAILED_TABLE.LEAVE_BY' },
	etaToBase: { id: 'eta-to-base', label: 'ROUTE_MONITORING.DETAILED_TABLE.ETA_TO_BASE' },
	tasksCount: { id: 'tasks-count', label: 'ROUTE_MONITORING.DETAILED_TABLE.NUMBER_OF_ORDERS' },
	totalCost: { id: 'total-cost', label: 'ROUTE_MONITORING.DETAILED_TABLE.TOTAL_COST' },
	weight: { id: 'weight', label: 'ROUTE_MONITORING.DETAILED_TABLE.TOTAL_WEIGHT' }
} as const satisfies Record<string, ColumnLabelDefinition>;

export const ROUTE_MONITOR_OPTIONAL_COLUMN_LABELS = {
	vehicleName: { id: 'vehicle-name', label: 'ROUTE_MONITORING.DETAILED_TABLE.VEHICLE_NAME' },
	expectedCost: { id: 'expected-cost', label: 'ROUTE_MONITORING.DETAILED_TABLE.EXPECTED_COST' },
	loadedWeight: { id: 'loaded-weight', label: 'ROUTE_MONITORING.DETAILED_TABLE.LOADED_WEIGHT' },
	expectedWeight: { id: 'expected-weight', label: 'ROUTE_MONITORING.DETAILED_TABLE.EXPECTED_WEIGHT' }
} as const satisfies Record<string, ColumnLabelDefinition>;

export const ROUTE_MONITOR_DYNAMIC_CAPACITY_LABELS = {
	loaded: 'ROUTE_MONITORING.DETAILED_TABLE.LOADED',
	expected: 'ROUTE_MONITORING.DETAILED_TABLE.EXPECTED'
} as const;

export const ROUTE_MONITOR_COLUMN_LABEL_DEFINITIONS = Object.values(ROUTE_MONITOR_COLUMN_LABELS);
